import { getTemplateLayouts } from "src/actions/layoutActions";

export const REQUEST_STANDARD_LAYOUTS = "request_template_layouts";
export const RECEIVE_STANDARD_LAYOUTS = "receive_template_layouts";
export const RECEIVE_STANDARD_LAYOUTS_ERROR = "receive_template_layouts_error";

const getTemplateLayoutsRedux = () => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_STANDARD_LAYOUTS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_STANDARD_LAYOUTS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: RECEIVE_STANDARD_LAYOUTS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const layouts = await getTemplateLayouts();
			return onSuccess(layouts);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

export { getTemplateLayoutsRedux };
